import { useContext, useEffect } from "react";
import { AppContext } from "../App";
import { t } from "../i18n";
import { Icon } from "../components/Icon";

export const ErrorPage = () => {
	const { isTransitioning, data } = useContext(AppContext);

	useEffect(() => {
		setTimeout(() => {
			sessionStorage.removeItem("Data");
			sessionStorage.removeItem("Data_expires");
		}, 100);
	}, []);

	return (
		<div
			className={
				"content content_error_page kensei_03" +
				(isTransitioning ? " fade-in" : "")
			}
		>
			<h2 className="error_page_taller_h2">{t("¡Lo sentimos!")}</h2>
			{data.bookingExists ? (
				<p className="error_page_taller_p">
					{t(
						"Ya tienes una reserva finalizada, por favor ponte en contacto con nuestro centro de atención al cliente."
					)}
				</p>
			) : (
				<>
					<p className="error_page_taller_p">
						{t(
							"Se ha producido un error en el proceso de tu reserva."
						)}
					</p>
					<p className="error_page_taller_p">
						{t(
							"Alguien de nuestro equipo se pondrá en contacto contigo para confirmar los detalles de tu reserva."
						)}
					</p>
				</>
			)}

			<a href="tel:+34937838304" className="error_phone">
				<Icon name="phone" className="error_icon" />
				<span>937 838 304</span>
			</a>
		</div>
	);
};
